(function () {
  'use strict';

  if (window.PolyPouchAnalyticsGovernance) return;

  var state = {
    consentApi: 'loading',
    analyticsAllowed: false,
    hubspot: 'waiting-for-consent',
    sessionReplay: 'waiting-for-consent'
  };

  window.PolyPouchAnalyticsGovernance = state;

  function loadScript(id, src) {
    if (document.getElementById(id)) return;

    var script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = true;
    document.head.appendChild(script);
  }

  function afterPageLoad(callback) {
    if (document.readyState === 'complete') {
      callback();
      return;
    }

    window.addEventListener('load', callback, { once: true });
  }

  function whenIdle(callback, timeout) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: timeout });
      return;
    }

    window.setTimeout(callback, Math.min(timeout, 1000));
  }

  function loadHubSpotAnalytics() {
    if (state.hubspot === 'loaded') return;

    state.hubspot = 'loaded';
    loadScript('hs-script-loader', 'https://js-eu1.hs-scripts.com/144245295.js');
  }

  function loadSessionReplay() {
    if (state.sessionReplay === 'loaded') return;

    state.sessionReplay = 'loaded';
    window.hj = window.hj || function () {
      (window.hj.q = window.hj.q || []).push(arguments);
    };
    window._hjSettings = { hjid: 4939241, hjsv: 6 };

    loadScript(
      'hotjar-script-loader',
      'https://static.hotjar.com/c/hotjar-' + window._hjSettings.hjid + '.js?sv=' + window._hjSettings.hjsv
    );
  }

  function armSessionReplay() {
    if (state.sessionReplay === 'armed' || state.sessionReplay === 'loaded') return;

    state.sessionReplay = 'armed';

    var interactionEvents = ['pointerdown', 'keydown', 'touchstart', 'scroll'];
    var startSessionReplay = function () {
      interactionEvents.forEach(function (eventName) {
        window.removeEventListener(eventName, startSessionReplay);
      });
      loadSessionReplay();
    };

    interactionEvents.forEach(function (eventName) {
      window.addEventListener(eventName, startSessionReplay, {
        passive: true,
        once: true
      });
    });
  }

  function applyConsent() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;

    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') {
      state.consentApi = 'unavailable';
      return;
    }

    state.consentApi = 'ready';
    state.analyticsAllowed = privacy.analyticsProcessingAllowed();

    if (!state.analyticsAllowed) {
      state.hubspot = state.hubspot === 'loaded' ? 'loaded' : 'blocked-by-consent';
      state.sessionReplay = state.sessionReplay === 'loaded' ? 'loaded' : 'blocked-by-consent';
      return;
    }

    afterPageLoad(function () {
      whenIdle(loadHubSpotAnalytics, 1500);
    });
    armSessionReplay();
  }

  document.addEventListener('visitorConsentCollected', applyConsent);

  if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
    state.consentApi = 'unavailable';
    return;
  }

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    function (error) {
      if (error) {
        state.consentApi = 'error';
        return;
      }

      applyConsent();
    }
  );
})();
